import { FieldFilterType } from './FieldType';
import { SortDirection } from './SortDirection';

export class FilterSortList {
    filter: { techName: string, value: any, type }[];
    sort: { techName?: string, direction?: SortDirection };

    constructor() {
        this.filter = [];
        this.sort = {};
    }
}

